// Workflow schedule (WS-D): the schedule DTO of the contract.
//
// The preset map and `compilePreset` live in `@septima/workflow`, because the
// canvas package reads them too. This module exports them again, so a caller
// of the contract keeps one import.

import { z } from 'zod';

export {
    WORKFLOW_SCHEDULE_PRESETS,
    WORKFLOW_SCHEDULE_PRESET_KEYS,
    compilePreset,
    isWorkflowSchedulePresetKey,
    type WorkflowSchedulePresetKey,
} from '@septima/workflow';

/** The schedule shape returned by `getSchedule` (null when unscheduled). */
export const workflowScheduleDtoSchema = z.object({
    cron: z.string(),
    presetKey: z.string().nullable(),
    enabled: z.boolean(),
    lastRunAt: z.string().nullable(),
});
export type WorkflowScheduleDto = z.infer<typeof workflowScheduleDtoSchema>;
